import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

export const stationsFilterSchema = z.object({
	search: optionalFilterString,
	street: optionalFilterString,
	operatorName: optionalFilterString,
	provider: optionalFilterString,
});

export type StationsFilter = z.infer<typeof stationsFilterSchema>;
